///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm = abcsetup.three_pm || {};
abcsetup.three_pm.price_change = abcsetup.three_pm.price_change || {};
abcsetup.three_pm.price_change.create = abcsetup.three_pm.price_change.create || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.three_pm.price_change.create = {

    /**
     *
     */
    init: function () {
        abcsetup.setTitle('3PM Price Change');
    },

}
